import React, { useEffect, useState } from "react";
import Views from "./views";
import { BrowserRouter as Router, Route, Switch, Redirect, useHistory } from "react-router-dom"; 
import { connect } from "react-redux";
import axios from "axios";
import jwtDecode from "jwt-decode";

const AUTH_PAGES = ["/en/login", "/en/register", "/en/forgot-password"];

const Routers = ({ auth }) => { 
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const history = useHistory();

  const isTokenValid = (token) => {
    if (!token) return false;
    try {
      const decoded = jwtDecode(token);
      return decoded.exp * 1000 > Date.now();
    } catch (error) {
      return false;
    }
  };
  
  useEffect(() => {
    const token = localStorage.getItem("token");
    const valid = isTokenValid(token);
  
    setIsAuthenticated(valid);

    if (valid) {
      axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    } else {
      if (history && history.push) {
        setTimeout(() => history.push("/en/login"), 0);
      }
    }
  }, [auth.token]);


  return (
    <Router>
      <Switch>
        {AUTH_PAGES.map((path, index) => (
          <Route key={index} path={path} render={(props) =>
            isAuthenticated ? <Redirect to="/panel/dashboard" /> : <Views {...props} />
          } />
        ))}
        <Route path="/panel/:page" render={(props) =>
          isAuthenticated ? <Views {...props} /> : <Redirect to="/en/login" />
        } />
        <Route path="/" render={(props) =>
          isAuthenticated ? <Redirect to="/panel/dashboard" /> : <Redirect to="/en/login" />
        } />

      </Switch>
    </Router>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(Routers);